// src/pages/LoginPage.js
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { BarChart3, Mail, Lock, Eye, EyeOff } from 'lucide-react';
import toast from 'react-hot-toast';

export default function LoginPage() {
  const { login, loading } = useAuth();
  const [form, setForm] = useState({ email: 'admin@investtracker.com', password: 'Admin@123' });
  const [showPwd, setShowPwd] = useState(false);
  const [err, setErr] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    const result = await login(form.email, form.password);
    if (!result.success) { setErr(result.error); toast.error(result.error); }
    else toast.success('Welcome back!');
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #0f172a 100%)',
      fontFamily: "'Inter', -apple-system, sans-serif"
    }}>
      <div style={{ width: '100%', maxWidth: 400, padding: '0 20px' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{
            width: 64, height: 64, background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
            borderRadius: 20, display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 16, boxShadow: '0 0 40px rgba(59,130,246,0.4)'
          }}>
            <BarChart3 size={30} color="#fff" />
          </div>
          <h1 style={{ color: '#fff', fontSize: 28, fontWeight: 700, margin: '0 0 4px', letterSpacing: '-0.5px' }}>InvestTrack</h1>
          <p style={{ color: '#64748b', fontSize: 14, margin: 0 }}>BSE · NSE Investment Management Portal</p>
        </div>

        {/* Card */}
        <div style={{
          background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(20px)',
          border: '1px solid rgba(255,255,255,0.1)', borderRadius: 20, padding: 36
        }}>
          <h2 style={{ color: '#e2e8f0', fontSize: 20, fontWeight: 600, margin: '0 0 24px' }}>Sign in to your account</h2>

          {err && (
            <div style={{ background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 10, padding: '10px 14px', color: '#fca5a5', fontSize: 13, marginBottom: 20 }}>
              {err}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ color: '#94a3b8', fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 6 }}>Email Address</label>
              <div style={{ position: 'relative' }}>
                <Mail size={16} style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: '#64748b' }} />
                <input
                  type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}
                  style={{
                    width: '100%', padding: '12px 14px 12px 42px', background: 'rgba(255,255,255,0.08)',
                    border: '1px solid rgba(255,255,255,0.15)', borderRadius: 10, color: '#e2e8f0',
                    fontSize: 14, outline: 'none', boxSizing: 'border-box'
                  }}
                  placeholder="admin@investtracker.com" required
                />
              </div>
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={{ color: '#94a3b8', fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 6 }}>Password</label>
              <div style={{ position: 'relative' }}>
                <Lock size={16} style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: '#64748b' }} />
                <input
                  type={showPwd ? 'text' : 'password'} value={form.password}
                  onChange={e => setForm({ ...form, password: e.target.value })}
                  style={{
                    width: '100%', padding: '12px 42px 12px 42px', background: 'rgba(255,255,255,0.08)',
                    border: '1px solid rgba(255,255,255,0.15)', borderRadius: 10, color: '#e2e8f0',
                    fontSize: 14, outline: 'none', boxSizing: 'border-box'
                  }}
                  placeholder="••••••••" required
                />
                <button type="button" onClick={() => setShowPwd(!showPwd)}
                  style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#64748b' }}>
                  {showPwd ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading} style={{
              width: '100%', padding: '13px', background: loading ? '#374151' : 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
              border: 'none', borderRadius: 10, color: '#fff', fontSize: 15, fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer', transition: 'opacity 0.2s',
              boxShadow: '0 4px 20px rgba(59,130,246,0.3)'
            }}>
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
          </form>

          <div style={{ marginTop: 20, padding: '12px 14px', background: 'rgba(59,130,246,0.1)', borderRadius: 10, border: '1px solid rgba(59,130,246,0.2)' }}>
            <p style={{ color: '#93c5fd', fontSize: 12, margin: 0 }}>Default: admin@investtracker.com / Admin@123</p>
          </div>
        </div>
      </div>
    </div>
  );
}
